import styles from './index.module.scss'
import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import { BatchImagesContext } from '../BatchImagesContext.js'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import API, { commonApiInvoker } from "@api/api";
import PSAIModal from "@PSAIComponents/PSAIModal";
import Utils from '@utils/utils';
import UploadBox from '../components/UploadBox/index.jsx'
import { Progress, Dropdown, Popover, Space, Table, message } from "antd"
import { UPLOAD_SOURCE, SERVICE_OPTIONS, TRYON_CLOTH_TYPE, CLOTH_TYPE } from "@utils/CONST"
import TableWrap from './table.jsx'


const ConfigPage = () => {
    const { fileList, setFileList } = useContext(BatchImagesContext)
    const navigate = useNavigate()
    const { isProCenter } = useLocation().state || {}
    const location = useLocation()
    const [uploading, setUploading] = useState(false)
    const [uploadFileList, setUploadFileList] = useState([])
    const [dataSource, setDataSource] = useState([])
    const [errorOpen, setErrorOpen] = useState(false)
    const [errorList, setErrorList] = useState([])
    const [successList, setSuccessList] = useState([])
    const [allUploadFail, setAllUploadFail] = useState(false)
    const isMounted = useRef(true)
    const { projectId } = useParams()
    const [projectType, setProjectType] = useState("")
    const [projectName, setProjectName] = useState("")
    const [total, setTotal] = useState(0) // 用户选完素材后生成图总数
    const [skuId, setSkuId] = useState("")
    const [taskId, setTaskId] = useState("")
    const [projectSerial, setProjectSerial] = useState("")

    // 再次编辑取参数
    const isEdit = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const skuId = params.get('skuId');
        const taskId = params.get('taskId');

        if (skuId) setSkuId(skuId)
        if (taskId) setTaskId(taskId)
        if (skuId && taskId) return true
    }, [location.search])


    // sku列表
    const listSkuByProject = async (editCurrentData) => {
        if (editCurrentData?.length === 0 || !editCurrentData) {
            try {
                const res = await API.listSkuByProject({
                    projectId,
                    skuId,
                    taskId,
                })
                if (res?.code == -5003) navigate("/home/product/batchImages")
                if (res.code === -5067) { navigate('/home/product/batchImages'); return }
                if (res.code !== 0) throw new Error(res.message)
                const skuList = res?.data?.skuDetailList || [];
                setProjectType(res?.data?.projectType);
                setProjectName(res?.data?.projectName);
                setProjectSerial(res?.data?.projectSerial);
                setTotal(res?.data?.total || 0)
                setDataSource([...skuList])
            } catch (err) {
                message.error(err.message || "请求失败");
            }
        } else {
            setDataSource([...editCurrentData])
        }
    };

    useEffect(() => {
        listSkuByProject()
        isMounted.current = true
        return () => {
            isMounted.current = false
        }
    }, [])

    // 遍历获取列表中的服装类型
    const checkedSkuRef = useRef(new Set());


    useEffect(() => {
        if (isEdit) return;
        if (projectType !== 'tryonBatch' || !dataSource || dataSource.length === 0 || uploading) return;

        const unprocessed = dataSource.filter(item => {
            const mainCloth = item?.inputImages?.find(img => img.mainImage === true);
            return (
                mainCloth &&
                (mainCloth.clothType == null || mainCloth.clothType === '') &&
                item.skuId && !checkedSkuRef.current.has(item.skuId)
            );
        });

        if (unprocessed.length === 0) return;

        const getClothType = async () => {
            for (const item of unprocessed) {
                if (!isMounted.current) break;
                checkedSkuRef.current.add(item.skuId);

                const mainCloth = item.inputImages.find(img => img.mainImage === true);
                if (!mainCloth?.url) {
                    checkedSkuRef.current.delete(item.skuId);
                    continue;
                }

                try {
                    const clothRes = await API.getClothType({ imageUrl: mainCloth.url });
                    if (clothRes?.code === 0) {
                        const newType = clothRes.data;
                        // 更新内存中的 item
                        mainCloth.clothType = newType;

                        // 只更新前端 dataSource，不调用保存接口
                        setDataSource(prev =>
                            prev.map(it => {
                                if (it.skuId !== item.skuId) return it;
                                const newImages = it.inputImages.map(img =>
                                    img.mainImage ? { ...img, clothType: newType } : img
                                );
                                return { ...it, inputImages: newImages, projectId };
                            })
                        );
                    }
                } catch (err) {
                    console.error('getClothType error', err);
                } finally {
                    checkedSkuRef.current.delete(item.skuId);
                }
            }
        };

        getClothType();
    }, [projectType, dataSource, uploading, isEdit]);


    useEffect(() => {
        if(dataSource.length === 0) return
        API.batchSaveSku([...dataSource]).then(res => {
            if (res?.code == 0) {
              
            }else {
                throw new Error(res.message)
            }
        }).catch(err => message.error(err.message))
    }, [dataSource])



    useEffect(() => {
        if (fileList.length > 0 && projectType) {
            handleUpload(fileList)
        }
    }, [fileList, projectType])


    // 首次批量上传
    function removeExtension(filename) {
        // 处理特殊文件名：'.' 和 '..'
        if (filename === '.' || filename === '..') return filename;

        const lastDot = filename.lastIndexOf('.');
        // 无后缀或隐藏文件（如 ".gitignore"）
        if (lastDot === -1 || lastDot === 0) return filename;

        return filename.substring(0, lastDot);
    }
    const handleUpload = async (fileList) => {
        console.log('fileList', fileList)
        const errorList = []
        const successList = []
        setErrorList([...errorList])
        setSuccessList([...successList])
        if (isEdit) return // 再次编辑不可上传素材

        try {
            setUploading(true)
            fileList = [...fileList].slice(0, 50)
            setUploadFileList(fileList)
            for (let file of fileList) {
                if (uploadAbort.current) { uploadAbort.current = false; break; }
                // 检查文件类型和宽高比
                try {
                    await Utils.validateImageFile(file, true)
                } catch (err) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                }
                if (uploadAbort.current) { uploadAbort.current = false; break; }
                // resize图片
                const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
                if (!resizeRes || !resizeRes.success) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                } else file = resizeRes.file
                if (uploadAbort.current) { uploadAbort.current = false; break; }
                // 上传图片
                const res = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.BATCHIMAGES)
                if (!res || !res.isLegal) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                }
                if (uploadAbort.current) { uploadAbort.current = false; break; }
                // 添加源素材到具体任务
                const url = res.data
                const skuName = removeExtension(file.name)
                // 保存sku
                API.batchSaveSku([{
                    projectId: projectId,
                    projectType: projectType,
                    skuName: skuName,
                    skuId: '',
                    inputImages: [{
                        url: url,
                        mainImage: true
                    }]
                }]).then(res => {
                    if (res?.code == 0) {
                        listSkuByProject()
                        successList.push({ url, name: skuName })
                        setSuccessList([...successList])
                    } else if (res?.code == -5065) {
                        message.error('上传已终止，每个项目最多上传50件商品！', 5000)
                        handleUploadAbort()
                    } else {
                        throw new Error(res.message)
                    }
                }).catch(err => message.error(err.message))

            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            setFileList([])
            setErrorList([...errorList])
            setSuccessList([...successList])
            setUploading(false)
            // 全部图片上传失败
            setAllUploadFail(fileList.length == errorList.length)
            // 图片上传失败弹窗
            if (errorList.length > 0) setErrorOpen(true)
        }
    }

    // 上传图片
    const handleReupload = () => {
        setUploadOpen(true)
        setErrorOpen(false)
    }
    const handleCancel = () => {
        setErrorList([])
        setErrorOpen(false)
    }
    const handleGoBack = () => {
        if (dataSource.length === 0) {
            API.batchRemoveProject({
                projectId,
            }).then(res => {
                if (res?.code == 0) {
                    navigate("/home/product/batchImages")
                } else throw new Error(res.message)
            })
        } else {
            navigate("/home/product/batchImages")
        }
    }
    // 正在上传的图片
    const remainUploadLength = useMemo(() => {
        return successList.length + errorList.length
    }, [uploadFileList, successList, errorList])

    // 上传更多
    const [uploadOpen, setUploadOpen] = useState(false)
    const handleAddMore = (file, fileList) => {
        handleUpload(fileList)
        setUploadOpen(false)
    }
    // 停止上传
    const uploadAbort = useRef(false)
    const handleUploadAbort = () => {
        setFileList([])
        uploadAbort.current = true
    }


    return (
        <>
            <div className={styles.ConfigPage}>
                <TableWrap
                    dataSource={dataSource}
                    projectSerial={projectSerial}
                    isProCenter={isProCenter}
                    setDataSource={setDataSource}
                    listSkuByProject={listSkuByProject}
                    projectType={projectType}
                    projectId={projectId}
                    uploading={uploading}
                    projectName={projectName}
                    total={total}
                    isEdit={isEdit} // 是否是重新编辑
                    editSkuId={skuId} // 重新编辑时
                    editTaskId={taskId}  // 重新编辑时
                    handleAddMore={handleAddMore} />
                {
                    uploading && <div className={styles.uploadNumber}>
                        <p><span>{remainUploadLength} / {uploadFileList.length} 正在上传</span> <span onClick={handleUploadAbort}>停止</span></p>
                        <Progress percent={Math.ceil(remainUploadLength / uploadFileList.length * 100)} showInfo={false} />
                    </div>
                }
            </div>
            <PSAIModal
                open={errorOpen}
                title="图片上传失败"
                okText={allUploadFail ? "重新上传" : "确定"}
                cancelText={allUploadFail ? "回到入口" : "继续上传"}
                maxWidth={520}
                onOk={allUploadFail ? handleReupload : handleCancel}
                onCancel={allUploadFail ? handleGoBack : handleReupload}
                onClose={() => setErrorOpen(false)}
            >
                {
                    allUploadFail ?
                        <div className={styles.ErrorUploadNotice1}>
                            <p>图片上传失败，清上传符合要求的图片</p>
                            <p style={{ color: "#FF0000" }}>请上传不大于30M，分辨率不小于500*500px，长宽比不超过2:1的JPG/PNG/WEBP图片</p>
                        </div> :
                        <div className={styles.ErrorUploadNotice2}>
                            <p>请上传不大于30M，分辨率不小于500*500px，长宽比不超过2:1的JPG/PNG/WEBP图片</p>
                            <ul className="_beauty_scrollbar">
                                {
                                    errorList.map((item, index) => (
                                        <li key={index}>{item.name}</li>
                                    ))
                                }
                            </ul>
                        </div>
                }
            </PSAIModal>
            <PSAIModal
                title="添加源素材"
                maxWidth={884}
                open={uploadOpen}
                footer={null}
                onCancel={() => setUploadOpen(false)}
            >
                <UploadBox
                    projectType={projectType}
                    onUpload={handleAddMore}
                />
            </PSAIModal>
        </>

    )
}

export default ConfigPage